export default __webpack_public_path__ + "static/media/howItWorks3.6eb27704.svg";